import { useMemo } from "react";

import { useAppliedConfigContext } from "contexts/applied-config";
import { mergeColumnDefs } from "helpers/tables";
import type { AppliedColumnCategoryCode } from "types/tables";
import type { ColumnDef } from "@tanstack/react-table";

export const useAppliedColumns = <T>(
  categoryCode: AppliedColumnCategoryCode,
  columnDefs: Array<ColumnDef<T>>,
) => {
  const { attributeMappingResponse } = useAppliedConfigContext();

  const appliedColumns = useMemo(
    () =>
      mergeColumnDefs<T>(categoryCode, columnDefs, attributeMappingResponse),
    [attributeMappingResponse, categoryCode, columnDefs],
  );

  return appliedColumns;
};
